import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface PageBreadcrumbProps {
  items?: BreadcrumbItem[];
  pageTitle?: string;
  actions?: React.ReactNode;
}

const PageBreadcrumb: React.FC<PageBreadcrumbProps> = ({ items = [], pageTitle, actions }) => {
  const { t } = useTranslation();
  const breadcrumbItems = items.length > 0
    ? items
    : pageTitle
      ? [{ label: pageTitle }]
      : [];

  return (
    <div className="flex flex-col flex-wrap justify-between gap-1 mb-8">
      {breadcrumbItems.length > 1 && (
        <nav className="print:hidden">
          <ol className="flex items-center gap-1.5">
            <li>
              <Link
              className="inline-flex items-center gap-1.5 text-sm text-text-tertiary"
              to="/"
            >
              {t('nav.home')}
              <svg
                className="stroke-current"
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.0765 12.667L10.2432 8.50033L6.0765 4.33366"
                  stroke=""
                  strokeWidth="1.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Link>
          </li>
          {breadcrumbItems.slice(0, -1).map((item, index) => (
            <li key={index}>
              {item.path ? (
                <Link
                  className="inline-flex items-center gap-1.5 text-sm text-text-tertiary"
                  to={item.path}
                >
                  {item.label}

                  {index !== breadcrumbItems.length - 2 && (
                    <svg
                      className="stroke-current"
                      width="17"
                      height="16"
                      viewBox="0 0 17 16"
                      fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.0765 12.667L10.2432 8.50033L6.0765 4.33366"
                      stroke=""
                      strokeWidth="1.2"
                      strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  )}
                </Link>
              ) : (
                <span className="text-sm text-text-tertiary">
                  {item.label}
                </span>
              )}
            </li>
          ))}
          {/* <li className="text-sm text-text-primary">
            {breadcrumbItems[breadcrumbItems.length - 1]?.label}
          </li> */}
        </ol>
      </nav>
      )}
      <div className="flex flex-col md:flex-row gap-2 justify-between items-start md:items-center">
        <h2
          className="text-xl font-semibold text-text-primary"
          x-text="pageName"
          data-testid="page-title"
        >
          {breadcrumbItems[breadcrumbItems.length - 1]?.label}
        </h2>

        {actions && (
          <div className="flex justify-end items-center">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
};

export default PageBreadcrumb;
